export default __webpack_public_path__ + "static/media/men-promo.519be298.png";